var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostJob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25229 5.91916C6.6665 6.50495 6.6665 7.44775 6.6665 9.33337V24C6.6665 25.8857 6.6665 26.8285 7.25229 27.4143C7.83808 28 8.78089 28 10.6665 28H21.3332C23.2188 28 24.1616 28 24.7474 27.4143C25.3332 26.8285 25.3332 25.8857 25.3332 24V9.33337C25.3332 7.44776 25.3332 6.50495 24.7474 5.91916C24.1616 5.33337 23.2188 5.33337 21.3332 5.33337H10.6665C8.78089 5.33337 7.83808 5.33337 7.25229 5.91916ZM11.9998 11C11.4476 11 10.9998 11.4478 10.9998 12C10.9998 12.5523 11.4476 13 11.9998 13H19.9998C20.5521 13 20.9998 12.5523 20.9998 12C20.9998 11.4478 20.5521 11 19.9998 11H11.9998ZM11.9998 16.3334C11.4476 16.3334 10.9998 16.7811 10.9998 17.3334C10.9998 17.8857 11.4476 18.3334 11.9998 18.3334H19.9998C20.5521 18.3334 20.9998 17.8857 20.9998 17.3334C20.9998 16.7811 20.5521 16.3334 19.9998 16.3334H11.9998ZM11.9998 21.6667C11.4476 21.6667 10.9998 22.1144 10.9998 22.6667C10.9998 23.219 11.4476 23.6667 11.9998 23.6667H17.3332C17.8855 23.6667 18.3332 23.219 18.3332 22.6667C18.3332 22.1144 17.8855 21.6667 17.3332 21.6667H11.9998Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostJob);
export default __webpack_public_path__ + "static/media/postJob.528da4ec3ce93a5a3871fd958cdbe74a.svg";
export { ForwardRef as ReactComponent };